var firstVistOfPage = true;

var klevu_uc = {
  showResultsData: function (response, callFrom) {
    var doc = document,
      noOtherDataAvailable = true,
      klevuSearchNoResult = doc.getElementById('klevuSearchNoResults'),
      arrowDiv = doc.getElementById('klevuArrow'),
      ptRsDiv = doc.getElementById('klevu-pt-rs-hover');
    // hide loader
    this.hideLoader();
    if (klevu_searchedTerm.length === 0) {
      return;
    }

    if (ptRsDiv) {
      ptRsDiv.style.display = "none";
    }
    //hide no-results div
    if (klevuSearchNoResult) {
      klevuSearchNoResult.style.display = "none";
    }
    // show autosuggestion
    if (klevu_showAdvancedAutosuggestionLayout) {
      this.showAdvancedAutoSuggestions(response.autoComplete, noOtherDataAvailable, response.meta);
    } else {
      this.showAutoSuggestions(response.autoComplete, response.meta);

      // show cms content
      this.showCmsContent(response.pages);

      // show filters
      this.showCategories(response.categories);

      // check if other data is available
      if ((response.autoComplete && response.autoComplete.length > 0) ||
        (response.categories && response.categories.length > 0) ||
        (response.pages && response.pages.length > 0)) {
        noOtherDataAvailable = false;
      }
      // show products
      this.showProducts(response.meta, response.result, noOtherDataAvailable, response.popularProducts);

      if (!noOtherDataAvailable || response.result.length > 0) {
        klevu_commons.showBannerAdForGivenTerm(klevu_searchedTerm);
      } else {
        klevu_commons.showBannerAdForGivenTerm("");
      }
    }
    doc.getElementById('klevuSearchingArea').style.cssText += ";display : block !important;";
    if (arrowDiv) {
      arrowDiv.style.display = "none"; // removing !important added at the time of clearing results.
    }

    function submitHendler(e) {
      if (response.result.length === 1) {
        e.preventDefault();
        window.location.href = directUrl;
      }
    }

    if (klevu_activeSearchBox) {
      klevu_activeSearchBox.addEventListener('input', function (e) {
        klevu_activeSearchBox.form.removeEventListener('submit', submitHendler, false);
      })
    }



    if (response.result.length === 1) {
      var result = response.result[0],
        directUrl = result.url,
        productSku = result.sku.replace(/\s+/g, '-').toUpperCase(),
        searchedTerm = klevu_searchedTerm.replace(/[^A-Z0-9]/ig, '-').toUpperCase();
      lastPartOfSku = productSku.split('-')[productSku.split('-').length - 1]

      if ((productSku === searchedTerm && klevu_activeSearchBox.form) || searchedTerm === lastPartOfSku) {

        klevu_activeSearchBox.form.addEventListener('submit', submitHendler, false);

        if (document.querySelector('#klevuProductHeading a')) document.querySelector('#klevuProductHeading a').href = directUrl;

        if (document.querySelector('#klevu_acList a')) {
          var suggestLink = document.querySelector('#klevu_acList a');
          suggestLink.href = directUrl;
          var newAnalytic = suggestLink.getAttribute('onmousedown');
          newAnalytic = newAnalytic.replace(/\'\/(.*?)\'/g, ("'" + directUrl + "'"));
          suggestLink.setAttribute('onmousedown', newAnalytic);
        }
      }
    }
  },
  showLandingPageData: function (product) {

    var toReturn = '',
      toAppendwithSalePrice = '',
      priceWithCurrency = '',
      appendCurrencyAtLast = false,
      salepriceClass = 'kuSalePrice',
      priceFormatter, priceToSet,
      showToLabel = false,
      additionalParams = '',
      keywords = document.getElementById('searchedKeyword').value,
      trackingParams = "",
      trackingEventHtml = "",
      i = 0,
      currentSwatch, swatchEventHandlerHtml,
      swatchFocusHandler, swatchBlurHandler, swatchColor,
      swatchCount = 0,
      swatchesShown = false,
      swatchesHtml = "",
      totalSwatchesToShow = 5;

    // if (firstVistOfPage) {
    //   //document.getElementById('listViewBtn').click();
    //   setKuViewList('list');
    //   firstVistOfPage = false;
    // }


    product = klevu_productCustomizations(product);
    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl;
    }

    if (klevu_apiKey === 'klevu-13939350527231') {
      toAppendwithSalePrice = '<span class="priceGreyText">Starting Price</span>';
    }

    if (klevu_userOptions.openProductClicksInNewWindow) {
      additionalParams = ' target="_blank"';
    } else {
      additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
    }
    trackingParams = '{' +
      'data: {' +
      'code: \'' + escape(product.productCode) + '\',' +
      'url: \'' + escape(product.productUrl) + '\',' +
      'name: \'' + escape(product.productName) + '\',' +
      'salePrice: \'' + escape(product.salePrice) + '\',' +
      'rating: \'' + escape(product.rating) + '\',' +
      'position: ' + product.productPosition + ',' +
      'category: \'' + escape(product.category) + '\',' +
      'sku: \'' + escape(product.sku) + '\'' +
      '},' +
      'apiKey: null,' +
      'keywordsLP: \'' + escape(keywords) + '\'' +
      '}';

    if (klevu_commons.isMobileDevice()) {
      trackingEventHtml = ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
    } else {
      trackingEventHtml = ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + '>';
    }
    try {
      // code for the result block
      toReturn += '<li>';
      toReturn += '<div class="klevuImgWrap">';
      toReturn += '<a href="' + product.productUrl.replace(/"/g, "%22") + '" ';
      if (klevu_userOptions.showRolloverImage && product.imageHover) {
        toReturn += ' onmouseleave = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');" ' +
          ' onmouseenter = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.imageHover) + '\', \'klevuProductImage-' + product.id + '\');" ';
      }
      toReturn += ' target="_blank" ' + trackingEventHtml +
        '<img id= "klevuProductImage-' + product.id + '" src="' + product.productImage + '" onerror="this.onerror=null;this.src=\'' +
        klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(product.productName) + '"/>';

      toReturn += '</a></div>'; //closing image wrap

      if (klevu_userOptions.showProductSwatches && product.swatches && product.swatches.swatch && product.swatches.swatch.length > 0) {
        totalSwatchesToShow = product.swatches.swatch.length > totalSwatchesToShow ? totalSwatchesToShow : product.swatches.swatch.length;
        for (i = 0; i < totalSwatchesToShow; i++) {
          currentSwatch = product.swatches.swatch[i];
          if (currentSwatch.image) {
            swatchesShown = true;
            swatchColor = currentSwatch.color.replace(/ /g, "").replace(/-/g, "");
            if (!currentSwatch.swatchImage && !klevu_commons.isValidCSSColor(swatchColor)) {
              swatchesHtml += '<div class="klevuSwatchItem klevuDefaultSwatch">';
            } else {
              swatchesHtml += '<div class="klevuSwatchItem">';
            }
            swatchFocusHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(currentSwatch.image) + '\', \'klevuProductImage-' + product.id + '\');';
            swatchBlurHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');';
            if (klevu_commons.isMobileDevice()) {
              swatchEventHandlerHtml = ' onclick = "' + swatchFocusHandler + '" ';
            } else {
              swatchEventHandlerHtml = ' onmouseleave = "' + swatchBlurHandler + '" onmouseenter = "' + swatchFocusHandler + '" ';
            }

            swatchesHtml += '<a href = "javascript:void(0);" class = "klevuSwatchLink" ' + swatchEventHandlerHtml;
            swatchesHtml += ' style = "background-color:' + swatchColor +
              '; background-image:url(\'' + currentSwatch.swatchImage + '\');" title="' + currentSwatch.color + '">';
            swatchesHtml += '</a></div>';
          } else {
            swatchCount += 1;
          }
        }
        if (product.swatches.swatch.length > totalSwatchesToShow) {
          swatchCount += product.swatches.swatch.length - totalSwatchesToShow;
        }
        if (!swatchesShown) {
          swatchesHtml = '<div class="klevuSwatches" style="display:none;">' + swatchesHtml;
        } else {
          swatchesHtml = '<div class="klevuSwatches">' + swatchesHtml;
        }
        swatchCount += (product.swatches.numberOfAdditionalVariants ? +(product.swatches.numberOfAdditionalVariants) : 0);
        if (swatchCount > 0 && swatchesShown) {
          swatchesHtml += '<div class = "klevuSwatchItem klevuSwatchMore">' +
            '<a href = "' + product.productUrl.replace(/"/g, "%22") + '" class = "klevuSwatchLink"' + trackingEventHtml +
            '<span class = "klevuSwatchMoreText">+' + swatchCount + '</span></a></div>';
        }

        swatchesHtml += '</div>';
        toReturn += swatchesHtml;
      }
    } catch (e) {}

    if ('undefined' !== typeof klevu_showDiscountBadge &&
      klevu_showDiscountBadge && product.discount != '' &&
      product.discount != '0' && product.discount != '0.0') {
      if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
        toReturn += '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText + ' ' +
          Number(product.discount).toFixed(0) +
          '%</div>';
      } else {
        toReturn += '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") +
          '</div>';
      }
    }
    toReturn += '<div class="kuNameDesc">';
    toReturn += '<div class="kuName"><a href="' + product.productUrl.replace(/"/g, "%22") +
      '" target="_blank" ' + trackingEventHtml;
    toReturn += product.productName + '</a></div>';
    if (product.desc) {
      var shortDescription = product.desc.replace(/\|less\|/g, "<").replace(/\|great\|/g, ">");
      var arrOfList = shortDescription.match(/<li>(.*?)<\/li>/g);

      if(arrOfList !== null){
        toReturn += '<div class="kuNameDescList"><p>' + arrOfList[0].replace("<li>", "").replace("</li>", "") + '</p><p>' + arrOfList[1].replace("<li>", "").replace("</li>", "") + '</p></div>';
      }
    }
    //toReturn += '<div class="kuDesc">' + product.productDescription + '</div>';
    if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
      Number(product.rating) <= 5 && Number(product.rating) >= 0) {
      var starWidth = 20 * Number(product.rating);
      toReturn += '<div class="kuStarsSmall">' +
        '<div class="kuRating" style="width:' + starWidth +
        '%;"></div></div>';
    }
    toReturn += '</div>';

    toReturn += '<div class="kuPrice">';
    if (klevu_showPrices) {
      if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
        toReturn += klevu_commons.showOriginalAndSalePrices('LANDING', product,
          salepriceClass, 'kuSalePrice kuSpecialPrice');
      } else {
        toReturn += klevu_commons.showProductPrices('LANDING', product,
          salepriceClass, 'kuSalePrice kuSpecialPrice');
      }
    }

    if (klevu_userOptions.vatCaption.trim().length > 0) {
      toReturn += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ')</div>';
    }

    if (product.totalProductVariants && product.totalProductVariants != '0' && !swatchesShown) {
      if (klevu_uiLabels.variants.indexOf("#") === -1) {
        toReturn += '<div class="klevu-variants">+' + product.totalProductVariants +
          ' ' + klevu_uiLabels.variants + '</div>';
      } else {
        toReturn += '<div class="klevu-variants">' +
          klevu_uiLabels.variants.replace("#", product.totalProductVariants) + '</div>';
      }
    }
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
      if ((product.inStock) && product.inStock === 'no') {
        toReturn += '<div class="klevu-out-of-stock">' +
          klevu_userOptions.outOfStockCaption + '</div>';
      }
    }

    toReturn += '</div>';
    if (klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)) {
      if (!(product.isCustomOptionsAvailable && product.isCustomOptionsAvailable === "yes") &&
        (!product.totalProductVariants || product.totalProductVariants == '0')) {
        toReturn += '<div class="kuAddtocart">' +
          '<input type="text" name="klevu-qty" id="klevu-qty-' +
          escape(product.productCode) + '" placeholder="' +
          klevu_uiLabels.addToCartPlaceholder + '"/>' +
          '<a href="javascript:klevu_lpSendProductToCart(\'' +
          escape(product.productCode) + '\', \'' +
          escape(product.productUrl) + '\', \'klevu-qty-' +
          escape(product.productCode) + '\');" ' +
          'class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
          '</div>';
      } else {
        toReturn += '<div class="kuAddtocart">' +
          '<a href="' + product.productUrl.replace(/"/g, "%22") +
          '" class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
          '</div>';
      }
      toReturn += '<div class="klevu-clearboth-listview"></div>';
    }
    toReturn += '<div class="kuClearLeft"></div>';
    toReturn += '</li>';

    return toReturn;
  },
  showAutocompleteProducts: function (product) {
    var productHtml = '',
      trackingParams = '',
      imgAlt,
      imgAltDiv = document.createElement('div');
    product = klevu_productCustomizations(product);
    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl;
    }
    if (klevu_userOptions.openProductClicksInNewWindow) {
      additionalParams = ' target="_blank"';
    } else {
      additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
    }
    trackingParams = '{' +
      'data: {' +
      'code: \'' + escape(product.productCode) + '\',' +
      'url: \'' + escape(product.productUrl) + '\',' +
      'name: \'' + escape(product.productName) + '\',' +
      'salePrice: \'' + escape(product.salePrice) + '\',' +
      'rating: \'' + escape(product.rating) + '\',' +
      'position: ' + product.productPosition + ',' +
      'category: \'' + escape(product.category) + '\',' +
      'sku: \'' + escape(product.sku) + '\'' +
      '}' +
      '}';
    imgAltDiv.innerHTML = product.productName;
    imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || "";
    productHtml += '<li>';
    productHtml += '<a href="' + product.productUrl.replace(/"/g, "%22") + '" class="klevu-result-box-l2" ';
    if (klevu_commons.isMobileDevice()) {
      productHtml += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');"  >';
    } else {
      productHtml += ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' +
        additionalParams + ' >';
    }

    productHtml += '<div class="klevu-img-wrap-l2"><img src="' + product.productImage +
      '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl +
      '\';" alt="' + klevu_commons.escapeHtml(imgAlt) + '" /></div>';
    if ('undefined' !== typeof klevu_showDiscountBadge &&
      klevu_showDiscountBadge && product.discount != '' &&
      product.discount != '0' && product.discount != '0.0') {
      if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
        productHtml += '<div class="klevu-discount-badge-l2">' +
          klevu_uiLabels.discountBadgeText + ' ' + Number(product.discount).toFixed(0) +
          '%</div>';
      } else {
        productHtml += '<div class="klevu-discount-badge-l2">' +
          klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") +
          '</div>';

      }
    }
    productHtml += '<div class="klevu-name-desc-l2">';
    productHtml += '<div class="klevu-name-l2">' + product.productName + '</div>';
    if (product.desc) {
      var shortDescription = product.desc.replace(/\|less\|/g, "<").replace(/\|great\|/g, ">");
      var arrOfList = shortDescription.match(/<li>(.*?)<\/li>/g);
      if(arrOfList !== null){
        productHtml += '<div class="kuNameDescList"><p>' + arrOfList[0].replace("<li>", "").replace("</li>", "") + '</p><p>' + arrOfList[1].replace("<li>", "").replace("</li>", "") + '</p></div>';
      }
      
    }
    //productHtml += '<div class="klevu-desc-l2">' + product.productDescription + '</div>';
    // show prices
    if (klevu_showPrices) {
      productHtml += '<div class="klevu-price-l2">';
      if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
        productHtml += klevu_commons.showOriginalAndSalePrices('SLIM', product, 'klevu-saleprice-l2',
          'klevu-saleprice-l2 klevu-special-price-l2');
      } else {
        productHtml += klevu_commons.showProductPrices('SLIM', product, 'klevu-saleprice-l2',
          'klevu-saleprice-l2 klevu-special-price-l2');
      }
      if (klevu_userOptions.vatCaption.trim().length > 0) {
        productHtml += '<span class="klevu-vat-caption-l2">(' +
          klevu_userOptions.vatCaption + ')</span>';
      }
      productHtml += '</div>';
    }
    if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
      Number(product.rating) <= 5 && Number(product.rating) >= 0) {
      var starWidth = 20 * Number(product.rating);
      productHtml += '<div class="klevu-stars-small-l2">' +
        '<div class="klevu-rating-l2" style="width:' + starWidth +
        '%;"></div></div>';
    }
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
      if (product.inStock && product.inStock === 'no') {
        productHtml += '<div class="klevu-out-of-stock-l2">' +
          klevu_userOptions.outOfStockCaption + '</div>';
      }
    }
    productHtml += '</div><div class="klevu-clear-left"></div></a></li>';
    return productHtml;
  },


}

function klevu_afterLandingResultsLoaded(results){
  if(firstVistOfPage){
    klevu_setKuView('list'); 
    firstVistOfPage = false;
  }
}